import React, { useEffect, useState, useMemo } from 'react';
import { useParams, Link } from 'react-router-dom';
import { api } from '../api';
import { Card, Alert, Table, Button, Badge } from 'flowbite-react';

export default function PropertyStats() {
  const { appUuid, propId } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    (async () => {
      try {
        const res = await api.get(`/properties/${propId}/views?app_uuid=${encodeURIComponent(appUuid)}`);
        setData(res);
      } catch (e) {
        setError(e.message);
      }
    })();
  }, [appUuid, propId]);

  const total = data?.total_views || 0;
  const title = data?.property?.title || 'Объект';

  const daily = useMemo(() => data?.daily || [], [data]);
  const views = useMemo(() => data?.views || [], [data]);

  if (error) return <Alert color="failure">{error}</Alert>;
  if (!data) return <Card><div>Загрузка…</div></Card>;

  return (
    <div className="grid gap-4">
      <Card>
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
          <h2 className="text-lg font-semibold">Статистика: {title}</h2>
          <div className="flex items-center gap-3">
            <Badge color="info">Всего просмотров: {total}</Badge>
            <Button as={Link} to={`/${appUuid}/properties`} size="sm">Назад к списку</Button>
          </div>
        </div>
      </Card>

      <Card>
        <h3 className="text-base font-semibold mb-2">Динамика по дням</h3>
        {daily.length === 0 ? (
          <div className="text-sm text-gray-500">Нет данных</div>
        ) : (
          <div className="overflow-x-auto">
            <Table hoverable>
              <Table.Head>
                <Table.HeadCell>Дата</Table.HeadCell>
                <Table.HeadCell>Просмотры</Table.HeadCell>
              </Table.Head>
              <Table.Body className="divide-y">
                {daily.map((r, idx) => (
                  <Table.Row key={idx} className="bg-white dark:border-gray-700 dark:bg-gray-800">
                    <Table.Cell>{r.date}</Table.Cell>
                    <Table.Cell>{r.count}</Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>
          </div>
        )}
      </Card>

      <Card>
        <h3 className="text-base font-semibold mb-2">Последние просмотры</h3>
        {views.length === 0 ? (
          <div className="text-sm text-gray-500">Просмотров пока нет</div>
        ) : (
          <div className="overflow-x-auto">
            <Table hoverable>
              <Table.Head>
                <Table.HeadCell>Когда</Table.HeadCell>
                <Table.HeadCell>Пользователь</Table.HeadCell>
                <Table.HeadCell className="hidden md:table-cell">Username</Table.HeadCell>
                <Table.HeadCell className="hidden lg:table-cell">IP</Table.HeadCell>
                <Table.HeadCell className="hidden xl:table-cell">User-Agent</Table.HeadCell>
              </Table.Head>
              <Table.Body className="divide-y">
                {views.map(v => (
                  <Table.Row key={v.id} className="bg-white dark:border-gray-700 dark:bg-gray-800">
                    <Table.Cell>{v.viewed_at || '—'}</Table.Cell>
                    <Table.Cell>{v.user?.name || v.user?.external_id || 'Гость'}</Table.Cell>
                    <Table.Cell className="hidden md:table-cell">{v.user?.username || '—'}</Table.Cell>
                    <Table.Cell className="hidden lg:table-cell">{v.ip || '—'}</Table.Cell>
                    <Table.Cell className="hidden xl:table-cell max-w-[360px] truncate" title={v.user_agent || ''}>{v.user_agent || '—'}</Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>
          </div>
        )}
      </Card>
    </div>
  );
}